import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { removeEventItem, updateEvent } from "../../../controller/c_events.js";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export default function EditEvent() {
  const userid = useSelector((state) => state.auth.login.userid);

  const navigate = useNavigate();
  const { state } = useLocation();
const event = state?.event;
  const [form, setForm] = useState(null);

  // -----------------------------
  // MAP API → FORM
  // -----------------------------
  const mapEventToForm = (evt) => ({
    eventid: evt.eventid,
    etitle: evt.etitle,
    isfree: evt.isfree,

    details:
      evt.sections?.map((s) => ({
        id: s.id,
        heading: s.title,
        content: s.detail,
      })) || [{ heading: "", content: "" }],

    schedules:
      evt.schedules?.map((s) => ({
        id: s.id,
        startdate: s.startdate,
        enddate: s.enddate,
        timeduration: s.timeduration,
        deliverymode: s.deliverymode,
      })) || [
        { startdate: "", enddate: "", timeduration: "", deliverymode: "" },
      ],
  });

  // -----------------------------
  // LOAD DATA
  // -----------------------------
  useEffect(() => {
    const load = async () => {
      
        setForm(mapEventToForm(event));
      
    };

    load();
  }, [state, event]);

  if (!form) return <div className="text-white p-4">Loading...</div>;

  // -----------------------------
  // INPUT HANDLERS
  // -----------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // -----------------------------
  // DYNAMIC HELPERS
  // -----------------------------
  const updateArray = (key, index, field, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: prev[key].map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  const addItem = (key, obj) => {
    setForm((prev) => ({
      ...prev,
      [key]: [...prev[key], obj],
    }));
  };

  const removeItem = async (key, index, itemid) => {
    if (form[key].length === 1) return;
    if (itemid) {
      const response=await removeEventItem(key, itemid);
      if(response?.state==="success"){
        toast.success("Item removed successfully");
      }else{
        return toast.error(response?.message || "Failed to remove item.");
      }
    }   
    setForm((prev) => ({
      ...prev,
      [key]: prev[key].filter((_, i) => i !== index),
    }));
  };

  // -----------------------------
  // SUBMIT (UPDATE)
  // -----------------------------
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    // CLEAN DATA BEFORE SENDING
    const payload = {
      eventid: form.eventid,
      etitle: form.etitle,
      isfree: Number(form.isfree),

      details: form.details.map((d) => ({
        id: d.id || null,
        title: d.heading,
        detail: d.content,
      })),

      schedules: form.schedules.map((s) => ({
        id: s.id || null,
        startdate: s.startdate,
        enddate: s.enddate,
        timeduration: s.timeduration,
        deliverymode: s.deliverymode,
      })),
    };

    const response = await updateEvent(payload, form.eventid, userid);

    if (response?.state) {
      toast.success(response?.message || "Event updated successfully");
        navigate("/admin/events");
    } else {
      toast.error(response?.message || "Failed to update event");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};

  // -----------------------------
  // UI
  // -----------------------------
  return (
    <div className="mt-2">
      <div className="card bg-dark text-white">
        <div className="card-body">
          <h3 className="mb-4">Edit Event</h3>

          <form onSubmit={handleSubmit}>
            {/* TITLE */}
            <div className="mb-3">
              <label>Event Title</label>
              <input
                type="text"
                name="etitle"
                className="form-control form-control-dark"
                value={form.etitle}
                onChange={handleChange}
              />
            </div>

            {/* FREE */}
            <div className="mb-3">
              <label>Is Free?</label>
              <select
                name="isfree"
                className="form-control form-control-dark"
                value={form.isfree}
                onChange={handleChange}
              >
                <option value={1}>Free</option>
                <option value={0}>Paid</option>
              </select>
            </div>

            {/* DETAILS */}
            <h5>Details</h5>
            {form.details.map((d, i) => (
              <div key={i} className="border p-3 mb-3 rounded">
                <input
                  className="form-control form-control-dark mb-2"
                  value={d.heading}
                  onChange={(e) =>
                    updateArray("details", i, "heading", e.target.value)
                  }
                />
                <textarea
                  className="form-control form-control-dark"
                  value={d.content}
                  onChange={(e) =>
                    updateArray("details", i, "content", e.target.value)
                  }
                />
                <button
                  type="button"
                  className="btn btn-sm btn-danger mt-2"
                  onClick={() => removeItem("details", i, d.id)}
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-outline-light mb-4"
              onClick={() =>
                addItem("details", { heading: "", content: "" })
              }
            >
              + Add Section
            </button>

            {/* SCHEDULES */}
            <h5>Schedules</h5>
            {form.schedules.map((s, i) => (
              <div key={i} className="border p-3 mb-3 rounded">
                <input
                  type="date"
                  className="form-control form-control-dark mb-2"
                  value={s.startdate}
                  onChange={(e) =>
                    updateArray("schedules", i, "startdate", e.target.value)
                  }
                />
                <input
                  type="date"
                  className="form-control form-control-dark mb-2"
                  value={s.enddate}
                  onChange={(e) =>
                    updateArray("schedules", i, "enddate", e.target.value)
                  }
                />
                <input
                  className="form-control form-control-dark mb-2"
                  value={s.timeduration}
                  onChange={(e) =>
                    updateArray("schedules", i, "timeduration", e.target.value)
                  }
                />
                <select
                  className="form-control form-control-dark"
                  value={s.deliverymode}
                  onChange={(e) =>
                    updateArray("schedules", i, "deliverymode", e.target.value)
                  }
                >
                  <option value="">Mode</option>
                  <option value="Online">Online</option>
                  <option value="Physical">Physical</option>
                </select>

                <button
                  type="button"
                  className="btn btn-sm btn-danger mt-2"
                  onClick={() => removeItem("schedules", i, s.id)}
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-outline-light mb-4"
              onClick={() =>
                addItem("schedules", {
                  startdate: "",
                  enddate: "",
                  timeduration: "",
                  deliverymode: "",
                })
              }
            >
              + Add Schedule
            </button>

            {/* ACTIONS */}
            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/admin/events")}
              >
                Cancel
              </button>

              <button type="submit" className="btn btn-primary">
                Update Event
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}